import { Link } from "react-router-dom";
import "../styles/pages/christmasButton.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCandyCane } from "@fortawesome/free-solid-svg-icons";

const ChristmasButton = (props) => {
  return (
    <div>
      {props.onClick ? (
        <div
          id={props.id}
          onClick={props.onClick}
          className="christmasButton py-1 px-3 pointer"
        >
          {props.text}{" "}
          <FontAwesomeIcon className="candyCane" icon={faCandyCane} />
        </div>
      ) : (
        <Link to={props.to}>
          <div className="christmasButton py-1 px-3 ">
            <h3 className="mt-0 mb-0 pointer"> {props.text}</h3>{" "}
            <FontAwesomeIcon className="candyCane" icon={faCandyCane} />
          </div>
        </Link>
      )}
    </div>
  );
};

export default ChristmasButton;
